import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debie-out-clinical',
  templateUrl: './debie-out-clinical.component.html',
  styleUrls: ['./debie-out-clinical.component.css']
})
export class DebieOutClinicalComponent implements OnInit {

  clinical_type_one_debie_model: any;
  clinical_type_two_debie_model_basal_oral: any;
  clinical_type_two_debie_model_basal_bolus: any;
  clinical_all_debie_model: any;

  tabs = {
    all: ['block', true],
    type_1: ['none', false],
    type_2_bo: ['none', false],
    type_2_bb: ['none', false]
  };

  constructor() {
    (window as any).run();

    this.clinical_type_one_debie_model = window['clinical_type_one_debie_model'];
    this.clinical_type_two_debie_model_basal_oral = window['clinical_type_two_debie_model_basal_oral'];
    this.clinical_type_two_debie_model_basal_bolus = window['clinical_type_two_debie_model_basal_bolus'];
    this.clinical_all_debie_model = window['clinical_all_debie_model'];
  }

  ngOnInit() {
  }

  activateTab(key: string) {
    for (let tab_key in this.tabs) {
      if (key === tab_key) {
        this.tabs[tab_key] = ['block', true];
      }
      else {
        this.tabs[tab_key] = ['none', false];
      }
    }
  }

}
